export default __webpack_public_path__ + "static/media/leather.28fb0b13.png";